// import { showIndex } from "../include/module";
// import { anchorLink } from "../include/module";
//
//
// (() => {
//
//   showIndex();
//   anchorLink();
//
// })();
var windowW       = $(window).width();
var windowH       = $(window).innerHeight();

//preload
import {preload} from "../include/module";
preload();


$(window).on('load' , function() {
  showIndex();

});


function showIndex() {
  setTimeout(function(){$('.bg-Item').addClass("show");},10);
  setTimeout(function(){$('#anime_Star').removeClass("hidden");},300);
  setTimeout(function(){$('#anime_Ttl_0').removeClass("hidden");},1000);
  setTimeout(function(){$('#anime_Ttl_1').removeClass("hidden");},1200);
  setTimeout(function(){$('#anime_Txt').removeClass("hidden");},1300);
  setTimeout(function(){showItem();},1800);
  setTimeout(function(){$('.anim_Item_Bg').addClass("show");},1800);
};

/*******************************************************

showItem

********************************************************/
const showItem = () => {
  var targetPositionAdd;

  targetPositionAdd = 100;
  if(windowW >= 1024){
      targetPositionAdd = 100;
  }else{
    targetPositionAdd = 60;
  }

  var scrollPosition = $(window).scrollTop();

  $(window).on("load resize", function () {
    windowW       = $(window).width();
    windowH       = $(window).innerHeight();
  });

  //ファーストビュー内にあるアイテム
  $('.anim_Item').each(function(){
    var targetPosition = $(this).offset().top;
    if(targetPosition < (windowH + scrollPosition)){
      $(this).addClass("show");
    }
  });

  //ファーストビューより下にあるアイテム（スクロールで表示）
  $(window).on('scroll',function(){
    scrollPosition = $(window).scrollTop();
    $('.anim_Item').each(function(){
      var targetPosition = $(this).offset().top;
      if(scrollPosition > targetPosition - windowH + targetPositionAdd){
        $(this).addClass("show");
      }
    });

  });
};



// WEBPACK FOOTER //
// ./src/popipa-movie_v0/assets/js/teaser/script.js